import React from "react";
import ContainerAdaptavel from "../../../extra-components/container-adaptavel";
import UsersPageAddEditUser from "./usuarios-tab/users-page-add-edit-user";
import UsersPageDeleteUser from "./usuarios-tab/users-page-delete-user";
import UsersPageUpdPassword from "./usuarios-tab/users-page-upd-password";
import VariableAddEdit from "./variaveis-tab/variable-add-edit";
import VariableDelete from "./variaveis-tab/variable-delete";
import GlobalVariableAddEdit from "./global-variavel-tab/global-variable-add-edit";
import GlobalVariableDelete from "./global-variavel-tab/global-variable-del";
import UsersXVariables from "./usuarios-tab/users-x-variables";
import UsersXMenu from "./usuarios-tab/users-x-menu";
import UsersXStore from "./usuarios-tab/users-x-store";

function UsersPageModal({ modal }) {
  let body;
  switch (modal.type) {
    case UsersPageModal.modal.ADD:
      body = <UsersPageAddEditUser />;
      break;
    case UsersPageModal.modal.EDIT:
      body = <UsersPageAddEditUser {...modal.data} />;
      break;
    case UsersPageModal.modal.DELETE:
      body = <UsersPageDeleteUser id={modal.data} />;
      break;
    case UsersPageModal.modal.UPD_PASSWORD:
      body = <UsersPageUpdPassword id={modal.data} />;
      break;
    case UsersPageModal.modal.VARIABLE_USER:
      body = <UsersXVariables {...modal.data} />;
      break;
    case UsersPageModal.modal.VARIABLE_ADD:
      body = <VariableAddEdit />;
      break;
    case UsersPageModal.modal.VARIABLE_EDIT:
      body = <VariableAddEdit {...modal.data} />;
      break;
    case UsersPageModal.modal.VARIABLE_DELETE:
      body = <VariableDelete id={modal.data} />;
      break;
    case UsersPageModal.modal.VARIABLE_GLOBAL_ADD:
      body = <GlobalVariableAddEdit />;
      break;
    case UsersPageModal.modal.VARIABLE_GLOBAL_EDIT:
      body = <GlobalVariableAddEdit {...modal.data} />;
      break;
    case UsersPageModal.modal.VARIABLE_GLOBAL_DELETE:
      body = <GlobalVariableDelete id={modal.data} />;
      break;
    case UsersPageModal.modal.MENU_USER:
      body = <UsersXMenu id={modal.data} />;
      break;
    case UsersPageModal.modal.STORE_USER:
      body = <UsersXStore id={modal.data} />;
      break;

    default:
      body = null;
  }

  return <ContainerAdaptavel>{body}</ContainerAdaptavel>;
}

UsersPageModal.modal = {
  ADD: "ADD",
  EDIT: "EDIT",
  DELETE: "DELETE",
  UPD_PASSWORD: "UPD_PASSWORD",
  VARIABLE_USER: "VARIABLE_USER",
  VARIABLE_ADD: "VARIABLE_ADD",
  VARIABLE_EDIT: "VARIABLE_EDIT",
  VARIABLE_DELETE: "VARIABLE_DELETE",
  VARIABLE_GLOBAL_ADD: "VARIABLE_GLOBAL_ADD",
  VARIABLE_GLOBAL_EDIT: "VARIABLE_GLOBAL_EDIT",
  VARIABLE_GLOBAL_DELETE: "VARIABLE_GLOBAL_DELETE",
  MENU_USER: "MENU_USER",
  STORE_USER: "STORE_USER",
};

export default UsersPageModal;
